module.exports = __webpack_public_path__ + "img/product.3b6fdea9.png";